import { Pagination } from '@/Domain/Procedures/RepositoryModifiers/Pagination'
import { AccountId } from '@/Domain/Account/AccountId'
import { AvailableOrder, ProcedureFilters } from '@/Domain/Procedures/RepositoryModifiers'
import { ExpedienteFilters } from '@/Domain/Expediente'
import { ExpedienteOrdering } from '@/Domain/Expediente/ExpedienteOrdering'
import { AvailableExpedienteOrderBy } from '@/Domain/Expediente/AvailableExpedienteOrderBy'

export class FetchAllExpedienteByUserCommand {
  private _pagination!: Pagination
  private _filters!: ExpedienteFilters
  private _ordering!: ExpedienteOrdering
  private _accountId!: AccountId

  constructor (accountId: AccountId, paginationData?: Pagination, filters?: ExpedienteFilters, ordering?: ExpedienteOrdering) {
    if (paginationData && paginationData.page < 1) {
      throw new RangeError('Page could not be lower than 1')
    }
    if (paginationData && paginationData.itemsPerPage < 1) {
      throw new RangeError('Items per Page could not be lower than 1')
    }
    this.ensureData(paginationData, filters, ordering)
    if (paginationData) {
      this._pagination = paginationData
    }
    if (filters) {
      this._filters = filters
    }
    if (ordering) {
      this._ordering = ordering
    }

    this._accountId = accountId
  }

  page (): number {
    return this._pagination.page
  }

  itemsPerPage (): number {
    return this._pagination.itemsPerPage
  }

  filters (): ProcedureFilters {
    return this._filters
  }

  ordering (): ExpedienteOrdering {
    return this._ordering
  }

  accountId (): AccountId {
    return this._accountId
  }

  ensureData (paginationData?: Pagination, filters?: ExpedienteFilters, ordering?: ExpedienteOrdering): void {
    if (!paginationData) {
      this._pagination = { page: 1, itemsPerPage: 10 }
    }
    if (!filters) {
      this._filters = { numExpediente: '', province: '', lote: '' }
    }
    if (!ordering) {
      this._ordering = { orderBy: 'numExpediente' as AvailableExpedienteOrderBy, order: 'DESC' as AvailableOrder }
    }
  }
}
